import apiClient from './apiClient';

export const tagsApi = {
	getAll: async (orgId) => {
		if (!orgId) {
			throw new Error('Organization ID is required');
		}
		try {
			const response = await apiClient.get(
				`/api/tags/organization/${orgId}`
			);
			return response.data;
		} catch (error) {
			console.error('Get tags error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to fetch tags'
			);
		}
	},

	create: async (tag) => {
		try {
			const response = await apiClient.post(`/api/tags`, tag);
			return response.data;
		} catch (error) {
			console.error('Create tag error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to create tag'
			);
		}
	},

	update: async (tagId, tag) => {
		try {
			const response = await apiClient.put(`/api/tags/${tagId}`, tag);
			return response.data;
		} catch (error) {
			console.error('Update tag error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to update tag'
			);
		}
	},

	delete: async (tagId) => {
		try {
			await apiClient.delete(`/api/tags/${tagId}`);
		} catch (error) {
			console.error('Delete tag error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to delete tag'
			);
		}
	},
};
